import * as React from "react";
const Alert = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 18 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.77047 1.96436C5.4802 1.96436 2.80623 4.63832 2.80623 7.92859V10.8014C2.80623 11.4077 2.54778 12.3322 2.23963 12.8491L1.09648 14.7477C0.390717 15.9207 0.877796 17.2229 2.17005 17.6602C6.45436 19.0917 11.0766 19.0917 15.361 17.6602C16.5637 17.2626 17.0906 15.8411 16.4345 14.7477L15.2914 12.8491C14.9932 12.3322 14.7347 11.4077 14.7347 10.8014V7.92859C14.7347 4.64826 12.0508 1.96436 8.77047 1.96436Z"
      stroke={props.stroke}
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M10.6096 2.25249C10.3014 2.16303 9.98334 2.09344 9.65531 2.05368C8.70103 1.9344 7.78651 2.00398 6.93164 2.25249C7.21991 1.5169 7.93562 1 8.77061 1C9.60561 1 10.3213 1.5169 10.6096 2.25249Z"
      stroke={props.stroke}
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.7523 18.0178C11.7523 19.658 10.4104 20.9999 8.77021 20.9999C7.95509 20.9999 7.19962 20.662 6.66284 20.1252C6.12606 19.5884 5.78809 18.8329 5.78809 18.0178"
      stroke={props.stroke}
      strokeWidth={1.5}
      strokeMiterlimit={10}
    />
  </svg>
);
export default Alert;
